/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const BurgerMenuIcon = createIcon(
  '0 0 20 20',
  <path d="M18 3H2v2h16zM2 9h16v2H2zm0 6h16v2H2z" />,
);
